import { useState } from 'react';
import { Link } from 'react-router-dom';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9q2uq4nlsngrm4llqk0';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpField = formData.get('company_alt') as string;
    if (hpField && hpField.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const payload = new URLSearchParams();
      payload.append('email', email);
      const response = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setStatus('success');
        setEmail('');
        form.reset();
      } else {
        const serverMsg = (parsed && (parsed as Record<string, unknown>).meta && ((parsed as Record<string, unknown>).meta as Record<string, unknown>).message)
          || (parsed && (parsed as Record<string, unknown>).message)
          || responseText
          || '订阅失败，请稍后重试';
        setErrorMsg(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后重试');
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查网络后重试');
      setStatus('error');
    }
  };

  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20dreamy%20gradient%20background%20with%20pink%20and%20cream%20tones%2C%20floating%20flower%20petals%2C%20ethereal%20Japanese%20aesthetic%2C%20gentle%20bokeh%20effect%2C%20clean%20minimal%20atmosphere%2C%20feminine%20delicate%20design&width=1600&height=700&seq=yuri-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/90 via-primary-100/60 to-background-50/90"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          加入百合会，不错过任何精彩
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-lg mx-auto">
          订阅百合会资讯，第一时间获取最新百合作品推荐、活动资讯和社区动态
        </p>

        {status === 'success' ? (
          <div className="flex items-center justify-center gap-2 text-accent-700 bg-accent-100/80 py-3 px-6 rounded-xl max-w-md mx-auto">
            <i className="ri-checkbox-circle-line text-lg"></i>
            <span className="text-sm font-medium">订阅成功！感谢你的加入</span>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form="百合会联系我们"
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="w-full sm:flex-1 px-5 py-3 rounded-full text-sm bg-background-50 border border-background-300/60 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 transition-all"
            />
            <input
              type="text"
              name="company_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="hp-field"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full sm:w-auto px-8 py-3 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 disabled:opacity-60 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {status === 'loading' ? '订阅中...' : '立即订阅'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-sm text-secondary-600 mt-3">{errorMsg}</p>
        )}

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="px-8 py-3 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多关于百合会
          </Link>
          <Link
            to="/category/manga"
            className="px-8 py-3 rounded-full text-sm font-medium border border-primary-300 text-primary-600 hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始浏览内容
          </Link>
        </div>
      </div>
    </section>
  );
}